<template>
  <div class="b2b-login__wrapper">
    <template>
      <div class="b2b-login__container">
        <gl-loader v-if="loading" />
      </div>

      <div class="b2b-login__bottom">
        SATOSHI EYE © {{ getFullYear }} ALL RIGHTS RESERVED
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
// Components
import GlLoader from '@/components/gl-loader'

export default {
  components: {
    GlLoader,
  },
  data() {
    return {
      loading: false,
      accessToken: '',
    }
  },
  computed: {
    ...mapGetters('termsOfUse', ['getCurrentTermsVersion']),
    ...mapGetters('user', ['isLogin']),
    getFullYear() {
      return new Date().getFullYear()
    },
  },
  async mounted() {
    this.accessToken = this.$route.query.access_token

    if (this.accessToken) {
      this.initLogin()
    } else {
      this.$toast.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Token is missing',
        life: 3000,
      })
    }
  },
  methods: {
    ...mapMutations({
      SET_USER_TOKEN: 'user/SET_USER_TOKEN',
      SET_USER_ID: 'user/SET_USER_ID',
      REMOVE_USER_TOKEN: 'user/REMOVE_USER_TOKEN',
      SET_USER_REFRESH_TOKEN: 'user/SET_USER_REFRESH_TOKEN',
      SET_USER_DATA: 'user/SET_USER_DATA',
      REMOVE_USER_ID: 'user/REMOVE_USER_ID',
    }),
    ...mapActions('user', ['getMe', 'b2bAuth']),
    async initLogin() {
      this.loading = true
      await this.clearAuthData()
      await this.b2bAuth({ token: this.accessToken })
        .then(async ({ success, data }) => {
          if (!success) return
          this.SET_USER_TOKEN(data)
          this.SET_USER_REFRESH_TOKEN(data)
          this.SET_USER_ID(data)
          await this.getMe()
          this.leavePage()
        })
        .catch(({ response: { data } }) => {
          if (data.code === 403) {
            this.$router.push({ name: '403' })
            return
          }

          setTimeout(() => {
            this.leavePage()
          }, 3000)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearAuthData() {
      this.REMOVE_USER_TOKEN()
      this.REMOVE_USER_ID()
      this.SET_USER_DATA({})
    },
    leavePage() {
      const to = localStorage.getItem('to.fullPath')

      if (to) {
        this.$router.push(to)
      } else {
        this.$router.push({ name: 'source-of-funds' })
      }
    },
  },
}
</script>

<style scoped>
.b2b-login__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100px;
  height: 100%;
}
.b2b-login__container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.b2b-login__bottom {
  font-weight: 500;
  font-size: 12px;
  color: var(--Texts-General-Secondary);
  text-align: center;
  margin-bottom: 24px;
}
</style>
